import React, { useState, useEffect } from 'react';
import styles from '../css/comuns/LocationSelector.module.css';
import { useNavigate } from 'react-router-dom';
import { config } from '../../data';


const citiesByState = {
    pb: [
        { value: 'joao-pessoa', text: 'João Pessoa' },
        { value: 'patos', text: 'Patos' },
        { value: 'teixeira', text: 'Teixeira' },
        { value: 'coremas', text: 'Coremas' },
        { value: 'sao-mamede', text: 'São Mamede' },
        { value: 'malta', text: 'Malta' },
        { value: 'brejo-do-cruz', text: 'Brejo do Cruz' }
    ],
    pe: [
        { value: 'santa-terezinha', text: 'Santa Terezinha' }
    ]
};

const allCities = Object.values(citiesByState).flat();

const LocationSelector = () => {
    const [state, setState] = useState('');
    const [city, setCity] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    useEffect(() => {
        if ("geolocation" in navigator) {
            navigator.permissions.query({ name: 'geolocation' }).then(function (result) {
                if (result.state === 'granted') {
                    getUserLocation();
                }
            });
        }
    }, []);

    const updateCitySelect = (selectedState) => {
        setState(selectedState);
        setCity('');
    };

    const getUserLocation = () => {
        if ("geolocation" in navigator) {
            setLoading(true);

            const options = {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0
            };

            navigator.geolocation.getCurrentPosition(
                (position) => getLocationData(position.coords.latitude, position.coords.longitude),
                (error) => {
                    console.error("Error getting user location:", error);
                    setLoading(false);
                    setMessage(config.texts.locationSelector.erroGeo);
                },
                options
            );
        } else {
            setMessage(config.texts.locationSelector.geoNaoSuportado);
        }
    };

    const getLocationData = (latitude, longitude) => {
        fetch(`https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=pt`)
            .then(response => response.json())
            .then(data => {
                const state = data.principalSubdivision;
                const city = data.city;

                const matchedCity = allCities.find(c => c.text.toLowerCase() === city.toLowerCase());

                if (matchedCity) {
                    const stateOption = Object.keys(citiesByState).find(key =>
                        citiesByState[key].some(cityObj => cityObj.value === matchedCity.value)
                    );
                    if (stateOption) {
                        setState(stateOption);
                        setCity(matchedCity.value);
                    }
                    setMessage('');
                } else {
                    setMessage(config.texts.locationSelector.cidadeIndisponivel);
                }

                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching location data:', error);
                setLoading(false);
                setMessage(config.texts.locationSelector.erroGeo);
            });
    };

    const handleSubmit = () => {
        if (city) {
            setLoading(true);
            setTimeout(() => {
                const redirectUrl = city === 'joao-pessoa' ? "/" : `/${city}`;
                window.location.href = redirectUrl;
            }, 1000);
        }
    };

    return (
        <div className={`${styles.login_container} ${styles.container_login}`}>
            <div className={styles['inner-container_login']}>
                <div className={styles.card_login}>
                    <div className={styles['card-body_login']}>
                        <div className={styles.logo_login}>
                            <img src={config.images.logos.main} alt="Oni logo" />
                        </div>
                        <div className={styles.divider_login}></div>
                        <h1 className={styles.title_login}>Bem-vindo! Selecione sua localização</h1>
                        <button onClick={getUserLocation} className={`${styles.btn_login} ${styles['btn-secondary_login']} w-100 mb-3`}>
                            <i className="fas fa-map-marker-alt me-2"></i>Usar minha localização atual
                        </button>
                        <select
                            value={state}
                            onChange={(e) => updateCitySelect(e.target.value)}
                            className={styles['form-select_login']}
                        >
                            <option value="">Escolha um estado</option>
                            <option value="pb">Paraíba - PB</option>
                            <option value="pe">Pernambuco - PE</option>
                        </select>
                        <select
                            value={city}
                            onChange={(e) => setCity(e.target.value)}
                            className={styles['form-select_login']}
                            disabled={!state}
                        >
                            <option value="">Localizar cidade</option>
                            {state && citiesByState[state].map((city) => (
                                <option key={city.value} value={city.value}>{city.text}</option>
                            ))}
                        </select>
                        <button
                            onClick={handleSubmit}
                            className={`${styles.btn_login} ${styles['btn-primary_login']} w-100`}
                            disabled={!state || !city}
                        >
                            <i className="fas fa-arrow-right me-2"></i>Continuar
                        </button>
                        {loading && (
                            <div className={`${styles['loading-indicator_login']} mt-3`}>
                                <i className="fas fa-circle-notch fa-spin fa-2x"></i>
                                <p className="mt-2">Carregando...</p>
                            </div>
                        )}
                        {message && (
                            <div className={`${styles['alert-info_login']} mt-3`}>{message}</div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );

};

export default LocationSelector;